export function formatContractValue(value) {
	if (value == null || value === "") return "—";
	const num = Number(String(value).replace(",", "."));
	if (Number.isNaN(num)) return "—";
	return num.toLocaleString("pt-BR", {
		style: "currency",
		currency: "BRL",
	});
}

export function parseContractValueInput(value) {
	if (value == null || String(value).trim() === "") return null;
	const num = Number(String(value).replace(",", "."));
	if (Number.isNaN(num) || num < 0) return null;
	return Math.round(num * 100) / 100;
}
